<template>
    <section class="detail">

        <navigation selected="order"></navigation>

        <div class="">

            <div id="ads" class="ads" v-if="shouldShowAd">
                <div class="content">
                    <div class="img">
                        <img :src="adImageSrc" :alt="adImageSrc"/>
                    </div>
                    <div class="text">
                        <h2 v-html="giftCardAd.title[lang]"></h2>
                        <div v-html="giftCardAd.content[lang]" class="text-content"></div>
                    </div>
                </div>
                <button type="button" class="close" aria-label="Fermer" @click="closeAds()"></button>
            </div>

            <form>


                <div class="sub-tab-menu-spacer" ref="subTabMenuSpacer">
                    <div class="sub-tab-menu" :class="{ 'filtersOpen': subMenuOpen }" ref="subTabMenu">
                        <button type="button" @click="subMenu()">Filtres rapides</button>
                        <div class="inner">
                            <ul>
                                <template v-for="(group, groupIndex) in productGroups" :key="`group-${group.id}`"
                                >
                                    <li class="separator"
                                        v-if="isDifferentGroupFromPrevious(groupIndex, productGroups)"><a href="#">|</a>
                                    </li>
                                    <li>
                                        <a :href="`#id-${groupIndex}`"
                                           class="smooth-scroll-jump"
                                           ref="productSectionsJumplinks">{{ group.name[ lang ] }}
                                        </a>
                                    </li>
                                </template>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="tab-content" id="myTabContent">

                    <div class="tab-pane active" id="a-la-carte" role="tabpanel" aria-labelledby="a-la-carte-tab">

                        <!-- Group 1 -->
                        <fieldset class="order"
                                  v-for="(group, groupIndex) in productGroups"
                                  :key="`group-${group.id}`"
                                  :id="`id-${groupIndex}`"
                                  ref="productSections">

                            <div class="section-price-banner" :style="groupHeadingBannerStyle(groupIndex)">
                                <legend class="title inner">
                                    <span class="pre">{{ copydeck.page_order.title_gift_card[ lang ] }}</span>
                                    {{ group.name[ lang ] }}
                                </legend>
                            </div>

                            <div class="inner">

                                <span class="instruction"
                                      v-if="got(group, 'subtitle', lang)"> {{ group.subtitle[ lang ] }}</span>
                                <span class="warning" v-if="got(group, 'note', lang)" v-html="group.note[lang]"></span>

                                <div class="products-group">
                                    <div class="form_group flex-end"
                                         v-for="(product,productIndex) in group.products.sort( (a,b) => a.position - b.position)"
                                         :key="`form-${group.id}-${product.id}`"
                                         :name="`form-${group.id}-${product.id}`"
                                         :id="`product-${group.id}-${product.id}`">

                                        <!-- if we have more we should think to use a generic component loader -->
                                        <product-counter v-if="product.price > 1"
                                                         :product="product"
                                                         :group="group"
                                                         :group-index="groupIndex"

                                                         :get-order="getOrder"
                                                         :is-open="isOpen"
                                                         :on-order-change="onOrderChange"
                                                         :got="got"></product-counter>

                                        <product-input v-else-if="product.price === 1"
                                                       :product="product"
                                                       :group="group"
                                                       :group-index="customGiftCardFellowProductsGroupIndex"
                                                       :min="product.min"
                                                       :max="product.max"
                                                       :get-order="getOrder"
                                                       :is-open="isOpen"
                                                       :on-order-change="onOrderChange"
                                                       @change="onOrderChange"
                                                       @validity="onValidity"
                                                       :got="got"></product-input>
                                    </div>
                                    <!-- div.form_group -->

                                    <div class="wrapper_btn">
                                        <button type="button"
                                                class="cta next"
                                                @click="() => addPending(groupIndex)"
                                                :disabled="!canAddToCart(groupIndex)"
                                                :id="`button-${groupIndex}`">
                                            <span class="added-text">{{
                                                    copydeck.page_order.label_added[ lang ]
                                                }}</span>
                                            <span class="idle-text">{{
                                                    copydeck.page_order.btn_add_to_cart[ lang ]
                                                }}</span>
                                        </button>
                                        <router-link :to="getRoute('recap')" v-if="orderCount > 0" class="btn-go-to-cart">
                                            <span class="text" v-html="copydeck.page_order.goToCart[ lang ]"></span>
                                            <span class="icon"><svg xmlns="http://www.w3.org/2000/svg" width="24px"
                                                                    height="24px" fill="none" stroke-width="1.5"
                                                                    viewBox="0 0 24 24" color="white"><path fill="white"
                                                                                                            stroke="white"
                                                                                                            stroke-width="1.5"
                                                                                                            stroke-linecap="round"
                                                                                                            stroke-linejoin="round"
                                                                                                            d="M19.5 22a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM9.5 22a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"></path><path
                                                stroke="white" stroke-width="1.5" stroke-linecap="round"
                                                stroke-linejoin="round"
                                                d="M16.5 4H22l-2 11h-4.5m1-11-1 11m1-11h-5.75m4.75 11h-4m-.75-11H5l2 11h4.5m-.75-11 .75 11M5 4c-.167-.667-1-2-3-2M20 15H5.23c-1.784 0-2.73.781-2.73 2 0 1.219.946 2 2.73 2H19.5"></path></svg></span>
                                        </router-link>
                                    </div>
                                </div>

                            </div>
                        </fieldset>
                        <!-- End Group 1 -->



                    </div>

                    <!-- ************************************************************* -->


                    <div class="tab-pane" id="forfaits" role="tabpanel" aria-labelledby="forfaits-tab">

                    </div>
                </div>

                <div class="status-error" :aria-hidden="pageError === ''" v-show="pageError !== ''" ref="statusError">
                    {{ pageError }}
                </div>

<!--                <next-step-button :to="{name: 'Recap'}"-->
<!--                                  :can-submit="clickNext"-->
<!--                                  :label="copydeck.page_gift_card.btn_next_order[lang]"-->
<!--                                  :elementToFocusIfCannotProceed="statusError"></next-step-button>-->

            </form>

        </div>

    </section>
</template>

<script>
import Navigation     from "../components/Navigation.vue";
import NextStepButton from "../components/NextStepButton.vue";
import ProductCounter from "../components/ProductCounter.vue";
import ProductInput   from "../components/ProductInput.vue";

export default {
    name       : "Order",
    components : { NextStepButton, Navigation, ProductCounter, ProductInput },

    data ()
    {
        return {
            subMenuOpen : false,

        }
    },

    methods : {},


}
</script>

<script setup>

import { ref, computed, watch, onMounted, onUnmounted, nextTick } from "vue";
import { useMainStore }                                           from "../stores/main";
import { storeToRefs }                                            from "pinia";
import SpaAds                                                     from '../composables/SpaAds';
import { debounce }                                               from 'lodash/function';
import { dispatchWindowEvent, getPercentOfView }                  from '../composables/utils';

let store = useMainStore();
let {
        copydeck,
        productGroups,
        giftCardAd,
        lang,
        orders,
        pending,
        hasOrder,
        orderCount,
        customGiftCardFellowProductsGroupIndex,
    }     = storeToRefs( store );
let {
        addPendingToOrders,
        getOrderPrice,
        getRoute
    }     = store;

let activeTab      = ref( 'alacarte' );
let filteredGroups = computed( () => productGroups.value.filter( pg => pg.type === activeTab.value ) );

let arrOpen   = ref( [] );
let pageError = ref( "" );

let shouldShowAd = ref( false );

let subMenuOpen = ref( false );

let statusError = ref( null );


let subTabMenuSpacer       = ref( null );
let subTabMenu             = ref( null );
let debouncedSubmenuResize = ref( null );
let stickyObserver         = ref( null );
let stickyTopReference     = ref( 0 );

let productSections          = ref( null );
let productSectionsJumplinks = ref( null );
let followTocHighlightBound  = ref( false );


let canSubmitGroup = ref({});

function subMenu ()
{
    subMenuOpen.value = !subMenuOpen.value;
}

function addPending ( groupIndex )
{


    const buttonElement = document.getElementById( `button-${groupIndex}` );
    buttonElement.classList.add( 'added' );


    // there is a risk here if we click too fast
    setTimeout( () =>
    {
        buttonElement.classList.remove( 'added' );
    }, 3500 );


    addPendingToOrders( groupIndex );

    const customMonetaryValueField = document.querySelector( '.custom-price' );

    if ( customMonetaryValueField )
    {
        customMonetaryValueField.value = null;
    }

}

function clickNext ()
{
    let bOrder = hasOrder.value;

    const lowestOrder = orders.value.reduce( ( a, o ) =>
    {
        let price = getOrderPrice( o.id_product, orders.value );

        return a > price && price > 0 ? price : a;

    }, Number.POSITIVE_INFINITY );


    if ( !bOrder )
    {
        pageError.value = copydeck.value.page_gift_card.error_no_order[ lang.value ];
    }

    if ( lowestOrder < 25 )
    {
        bOrder          = false;
        pageError.value = copydeck.value.page_gift_card.error_order_too_low[ lang.value ];
    }

    // parent.debouncedResize;
    return bOrder;

}

function changeTab ( type )
{
    activeTab.value = type;
    // parent.debouncedResize;
}

function isActive ( type )
{
    return activeTab.value === type ? "active" : "";
}

function isOpen ( id )
{
    let open = arrOpen.value.find( o => o === id );

    return open !== undefined;
}

function got ( row, path, lang )
{
    if ( !row[ path ] )
        return false;

    let v;

    if ( lang !== undefined )
    {
        v = row[ path ][ lang ];
    } else
    {
        v = row[ path ];
    }


    return v && v !== "";
}

function getOrder ( product )
{
    let id_product = product.id;

    let productOrder = pending.value.find( o => o.id_product === id_product );

    if ( !productOrder )
        return 0;

    let quantity = productOrder.quantity;

    return quantity;
}

function onInvalid (id, details)
{
    canSubmitGroup.value[details.groupIndex] = false;
}

function onValidity (id, details)
{
    canSubmitGroup.value[details.groupIndex] = details.validity ?? false;
}

function onOrderChange ( id, details, groupIndex = -1 )
{
    //let productOrderIndex = orders.value.findIndex( o => o.id_product === id);
    let productOrderIndex = pending.value.findIndex( o => o.id_product === id );

    if ( productOrderIndex === -1 )
    {
        //orders.value.push( Object.assign({ id_product: id }, details));
        pending.value.push( Object.assign( { id_product : id }, details ) );
    } else
    {
        //let po = orders.value[productOrderIndex];
        let po = pending.value[ productOrderIndex ];
        po     = Object.assign( po, details );

        //orders.value[productOrderIndex] = po;
        pending.value[ productOrderIndex ] = po;
    }

}


function isDifferentGroupFromPrevious ( currentIndex, allGroups )
{

    // index 0 = first element = no previous element
    if ( currentIndex === 0 )
    {
        return false;
    }

    const currElementType = allGroups?.[ currentIndex ]?.type ?? null;
    const prevElementType = allGroups?.[ currentIndex - 1 ]?.type ?? null;


    return currElementType !== prevElementType;

}

watch ( () => pending, ( newValue, oldValue ) =>
    {
        console.log( 'pending changed', newValue );
    },
);
let canAddToCart = ( groupIndex ) =>
{
    function groupQuantityCounter ( accumulator, currentValue, index )
    {

        if ( currentValue.groupIndex === groupIndex )
        {
            accumulator += currentValue.quantity;
        }

        return accumulator;
    }

    const groupProductsQuantity = pending.value.reduce( groupQuantityCounter, 0 );

    let canSubmit = canSubmitGroup.value[ groupIndex ] ?? true;

    if (!canSubmit)
    {
        return false;
    }

    return (groupProductsQuantity > 0);
}


let groupHeadingBannerStyle = ( groupIndex ) =>
{

    const foundGroup = productGroups.value[ groupIndex ];


    if ( typeof (foundGroup?.data?.section_image?.formats ?? 'undefined') === 'undefined' )
    {
        return ''; // @todo : should probably add a default image somewhere
    }

    const foundFormat = foundGroup.data.section_image.formats.find( format => format.name === 'mockups_banner' );

    if ( !foundFormat )
    {
        return '';
    }


    return 'background-image: url(' + foundFormat.url + ');';

}


let adImageSrc = computed( () =>
{

    if ( !giftCardAd.value )
    {
        return '';
    }

    return lang.value === 'fr'
        ? giftCardAd?.value?.adImageUrlFr ?? ''
        : giftCardAd?.value?.adImageUrlEn ?? '';

} )

let adImageAlt = computed( () =>
{

    if ( !giftCardAd.value )
    {
        return '';
    }

    return lang.value === 'fr'
        ? giftCardAd?.value?.adImageAltFr ?? ''
        : giftCardAd?.value?.adImageAltEn ?? '';

} )


function setupAds ()
{


    if ( !giftCardAd.value )
    {
        shouldShowAd.value = false;
        return;
    }

    let ads            = new SpaAds();
    shouldShowAd.value = ads.shouldShowAd( giftCardAd.value.id );

}

function closeAds ()
{
    let ads = new SpaAds();
    ads.markAdAsSeen( giftCardAd.value.id );

    shouldShowAd.value = false;
}


function resizeAdjustments ()
{

    subTabMenuSpacer.value.style.height = 'auto';
    subTabMenu.value.style.height       = 'auto';

    const subTabMenuHeight = subTabMenu.value.getBoundingClientRect().height;

    subTabMenuSpacer.value.style.height = subTabMenuHeight + 'px';

    // values have changed, perhaps? Let's kill and set up the observer freshly
    if ( stickyObserver.value )
    {
        stickyObserver.value.unobserve( subTabMenuSpacer.value );
        stickyObserver.value = null;
        setupStickySubtabs();
    }


    if ( followTocHighlightBound.value )
    {
        findBiggestSectionOnScreenAndHighlightToc();
    }
}


function setupStickySubtabs ()
{

    // only want to bind this once
    if ( stickyObserver.value )
    {
        return;
    }


    stickyTopReference.value = getTopMenuHeight();


    stickyObserver.value = new IntersectionObserver(
        ( [ e ] ) =>
        {

            if ( !subTabMenu.value )
            {
                return;
            }

            const shouldPin = e.intersectionRatio < 1;

            if ( shouldPin )
            {
                subTabMenu.value.style.position = 'fixed';
                subTabMenu.value.style.top      = getTopMenuHeight() + 'px';
                subTabMenu.value.style.left     = '0px';
                subTabMenu.value.style.right    = '0px';

            } else
            {
                subTabMenu.value.style.position = 'relative';
                subTabMenu.value.style.top      = 0 + 'px';

                subTabMenu.value.style.left  = 'auto';
                subTabMenu.value.style.right = 'auto';
            }

        },
        {
            rootMargin : (getTopMenuHeight() * -1) + "px 0px 0px 0px",
            threshold  : [ 1 ],
        },
    );

    stickyObserver.value.observe( subTabMenuSpacer.value );

}

function unsetupSetupStickySubtabs ()
{

    if ( !stickyObserver.value )
    {
        return;
    }
    if ( subTabMenuSpacer.value )
    {
        stickyObserver.value.unobserve( subTabMenuSpacer.value );
    }
    stickyObserver.value = false;
}

function getTopMenuHeight ()
{
    const mainNav       = document.querySelector( '#main-site-nav' );
    const mainNavHeight = mainNav.getBoundingClientRect().height;

    // sometimes these steps are within the flow of the document,
    // sometimes it's fixed... and sticky itself
    const reservationSteps       = document.querySelector( '#reservations_steps_nav' );
    const menu2isFixed           = window.getComputedStyle( reservationSteps ).getPropertyValue( 'position' ) === 'fixed';
    const reservationStepsHeight = menu2isFixed ? reservationSteps.getBoundingClientRect().height : 0;

    const totalTop = menu2isFixed ? reservationStepsHeight : mainNavHeight;


    return totalTop;
}


let findBiggestSectionOnScreenAndHighlightToc = () =>
{
    let allRatios = [];


    if ( !productSections.value )
    {
        return;
    }

    // get all their ratios
    productSections.value.forEach( ps =>
    {
        const id = ps.getAttribute( 'id' );
        allRatios.push( { id, ratio : getPercentOfView( ps, 100 ) } );
    } )


    // find the highest one
    const highestIntersectionRatio = allRatios.reduce( function ( prev, current )
    {
        return (prev && prev.ratio > current.ratio) ? prev : current;
    } );

    // adjust the classes on the jumplinks
    productSectionsJumplinks.value.forEach( jl =>
    {
        if ( jl.getAttribute( 'href' ) === '#' + highestIntersectionRatio.id )
        {
            jl.classList.add( 'active' );
        }
        else
        {
            jl.classList.remove( 'active' );
        }
    } )

    return highestIntersectionRatio;
}

function bindTocHighlighter ()
{

    document.addEventListener( 'scroll', findBiggestSectionOnScreenAndHighlightToc );
    followTocHighlightBound.value = true;

}

function unbindTocHighlighter ()
{

    document.removeEventListener( 'scroll', findBiggestSectionOnScreenAndHighlightToc );
    followTocHighlightBound.value = false;
}


watch( () => hasOrder, ( newValue, oldValue ) =>
    {
        if ( newValue )
            pageError.value = "";
    },
);

onMounted( () =>
{
    setupAds();

    resizeAdjustments();
    findBiggestSectionOnScreenAndHighlightToc();
    bindTocHighlighter();

    if ( !debouncedSubmenuResize.value )
    {
        debouncedSubmenuResize.value = debounce( resizeAdjustments, 300 );

        window.addEventListener( 'resize', debouncedSubmenuResize.value );
    }


    setupStickySubtabs();

} )

onUnmounted( () =>
{
    if ( debouncedSubmenuResize.value )
    {

        window.removeEventListener( 'resize', debouncedSubmenuResize.value );
        debouncedSubmenuResize.value = false;
    }

    unsetupSetupStickySubtabs();
    unbindTocHighlighter();

} )
</script>
